import React from "react";
import { Link, useHistory } from "react-router-dom";

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-sm-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

//i18n
import { withTranslation } from "react-i18next";

//components
import OperatorAreaHeader from "../OperatorArea/components/Header/index";

const Header = ({ toggleRightSidebar }) => {
  /*
   * Toggles the sidebar
   */
  const toggleRightbar = () => {
    toggleRightSidebar();
  };

  const toggleFullscreen = () => {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };
  const history = useHistory();
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div
            className="d-flex m-auto"
            style={{ width: "100%", height: "inherit" }}
          >
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="17" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span>
                  <img
                    src={logoLightSvg}
                    alt="Tech4H"
                    height="50"
                    style={{ marginLeft: "-14px" }}
                  />
                </span>
                <span className="logo-lg">
                  <img src={logoLightPng} alt="Tech4H" height="40" />
                </span>
              </Link>
            </div>
            {(history.location.pathname === "/chats" || "/manager-panel") && (
              <OperatorAreaHeader />
            )}
          </div>
          <div className="d-flex text-nowrap">
            <div className="dropdown  d-lg-inline-block m-auto">
              <button
                type="button"
                onClick={toggleFullscreen}
                className="btn header-item noti-icon waves-effect d-none d-xl-inline-block"
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen"></i>
              </button>
              <NotificationDropdown />

              <ProfileMenu onclick={toggleRightbar} />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default withTranslation()(Header);
